<div class="add-associated-party-row" fxLayout="column">
  <div *ngFor="let participant of selectedParticipants">
    <fsx-participant-table
      #participantsField
      [combinedFilingData]="combinedFilingData"
      [participant]="participant"
      [isAssociatedParty]="true"
      [resolver]="resolver"
      [showIcons]="true"
      [fileUploadDocumentInfos]="fileUploadDocumentInfos"
      (clearParticipantEvent)="clearParticipantEventHandler(participant)"
    >
    </fsx-participant-table>

    <fsx-additional-fields-container
      [additionalFieldSpecs]="
        participantFieldSpec.participantFieldDefinition.additionalFields!
      "
      [additionalFieldValues]="additionalFieldValues"
      [resolver]="resolver"
      (additionalFieldValuesEvent)="additionalFieldValuesEventHandler($event)"
    >
    </fsx-additional-fields-container>
  </div>

  <fsx-basic-single-selection
    *ngIf="selectedParticipants.length < maxAllowed; else maxAllowedReached"
    [caption]="caption"
    [helpText]="''"
    [hint]="''"
    [fieldType]="fieldType.Selection"
    [width]="!!width ? width : '162px'"
    [selectionType]="selectionType"
    [inputDropdownOptions]="filteredDropdownOptions"
    [autoSelectSingleOption]="false"
    [required]="required"
    [dropdownOptionLink]="'Add Party'"
    (dropdownOptionLinkClicked)="dropdownOptionLinkClickedHandler()"
    (formControlEmitter)="participantformControl($event)"
    (selectedValue)="
      onParticipantSelected({
        value: $event,
        requestDocument: documentsGridRow.requestDocument,
        documentIndex: documentsGridRow.rowIndex,
      })
    "
  >
  </fsx-basic-single-selection>
  <ng-template #maxAllowedReached>
    <p>
      The maximum number of associated parties ({{ maxAllowed }}) has been
      reached
    </p>
  </ng-template>
</div>
